import {
    apiRequest,
    bobotKomponenPenilaianCreate, 
    bobotKomponenPenilaianUpdate,
    bobotKomponenPenilaianCriteriaList
} from "../../../../../../services/adapters/master/bobotKomponenPenilaianService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", bobotKomponenPenilaianCreate, {
            body: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", bobotKomponenPenilaianUpdate, {
            body: query
        }, true)
    }
    
    // fetchCriteriaList = async (query, cancelToken) => {
    //     return await apiRequest("get", bobotKomponenPenilaianCriteriaList, {
    //         cancelToken: cancelToken,
    //         params: query
    //     }, true)
    // }

}

export default CreateRepository